import { jsx as _jsx } from "react/jsx-runtime";
import styles from './style.module.scss';
function CommonAppButton({ variant = 'secondary', size = 'md', className, children, buttonText, type = 'button', ...rest }) {
    return (_jsx("button", { type: type, className: [styles.btn,
            styles[`btn-${variant}`],
            styles[`btn-${size}`],
            className]
            .filter(Boolean)
            .join(' '), ...rest, children: children ?? buttonText }));
}
export default CommonAppButton;
